import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from '@sentry/angular';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import {
  CategoryScale,
  Chart,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';

import {
  ClientSideRowModelModule,
  Module,
  ModuleRegistry,
  PaginationModule,
  ValidationModule,
  CellStyleModule,
  RowAutoHeightModule,
  QuickFilterModule,
} from 'ag-grid-community';
import { getResolvedEnvironment } from './app/shared/services/environment-config/environment-config.resolver';
import { getAvailableEnvironmentModes } from './app/shared/services/environment-config/environment-config.utils';

if (getAvailableEnvironmentModes().length === 0) {
  showNoEnvironmentConfiguredAlert();
} else {
  startApp();
}

function showNoEnvironmentConfiguredAlert(): void {
  window.alert(
    'No Environment Configured\n\nNo firebaseConfig was found for live, staging, or sandbox. Please check the environment configuration.',
  );
  window.location.reload();
}

function startApp(): void {
  const resolvedEnvironment = getResolvedEnvironment();

  const agGridModules: Module[] = [
    PaginationModule,
    ClientSideRowModelModule,
    CellStyleModule,
    RowAutoHeightModule,
    QuickFilterModule,
  ];
  if (!resolvedEnvironment.production) {
    agGridModules.push(ValidationModule);
  }
  ModuleRegistry.registerModules(agGridModules);

  dayjs.extend(utc);
  dayjs.extend(localizedFormat);

  Sentry.init({
    dsn: resolvedEnvironment.sentryDSN,
    dataCollection: { userInfo: true },
  });

  Chart.register(
    CategoryScale,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    Tooltip,
    Legend,
  );

  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
}
